export default __webpack_public_path__ + "static/media/tableau.802f8cc9.png";